import {
  ApiFee,
  ApiFeeBasis,
  ApiFeeDeductionFrequency,
  ApiFeeType
} from '@/api/_legacy/generated-api'

import { getGUID } from '.'

export const createFee = (
  feeType: ApiFeeType = 'LoanFee',
  feeRate = 0.001,
  feeDeductionFrequency: ApiFeeDeductionFrequency = 'None'
): ApiFee => ({
  feeId: 'feeId1',
  feeType,
  feeRate,
  feeDeductionFrequency,
  isVATApplicable: true,
  feeBasis: 'LoanAmount',
  feeDayCount: 'Act_360',
  counterPartyId: '1234'
})

export const createEmptyFee = (): ApiFee => ({
  feeId: getGUID(),
  counterPartyId: '',
  feeDayCount: 'Act_365',
  feeType: '' as ApiFeeType,
  feeBasis: '' as ApiFeeBasis,
  feeDeductionFrequency: '' as ApiFeeDeductionFrequency,
  isVATApplicable: null,
  feeRate: null
})
